// extracted by mini-css-extract-plugin
module.exports =  {"description":"_93444fe79c--description--RK73K","text":"_93444fe79c--text--qEv47"};